<!-- Loading screen when waiting for profile update -->
<div *ngIf="isWaitingForProfileUpdate" class="unsub-loading">
  <div class="unsub-loading-content">
    <h5 class="unsub-loading-title"><b>Annulation de votre abonnement en cours...</b></h5>
    <p class="unsub-loading-message">Veuillez patienter pendant que nous finalisons l'annulation de votre abonnement et le retour à la version Standard.</p>
    <p class="unsub-loading-message unsub-loading-message--small">Cette opération peut prendre quelques minutes. Vous serez automatiquement déconnecté après 2 minutes si le processus n'est pas terminé.</p>
    <div class="unsub-loader">
      <div class="unsub-spinner"></div>
    </div>
  </div>
</div>

<!-- Normal modal content -->
<div *ngIf="!isWaitingForProfileUpdate">
  <div class="modal-header">
    <h5 translate>param.modal.version.title</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body bff-text modalForm p-4" id="modalFormBody">
    <div class="bff-form-row mb-3">
      <div class="bff-form-group" *ngIf="isPremiumUser" [innerHTML]="'param.modal.version.unsubscribe-to-premium' | translate"></div>
      <div class="bff-form-group" *ngIf="isPremiumGiftedUser || isPremiumDiscoveryUser" [innerHTML]="'param.modal.version.unsubscribe-to-premium-gifted' | translate"></div>
      <div class="bff-form-group" *ngIf="isProUser" [innerHTML]="'param.modal.version.unsubscribe-to-pro' | translate"></div>
      <div class="bff-form-group" *ngIf="isEssentielUser" [innerHTML]="'param.modal.version.unsubscribe-to-essentiel' | translate"></div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="bff-button-container bff-button-container--center">
      <button type="button" class="bff-button bff-button--primary" (click)="confirm()" translate>toconfirm</button>
      <button type="button" class="bff-button bff-button--secondary" (click)="modal.dismiss('Cross click')">
        {{ 'cancel' | translate }}
      </button>
    </div>
  </div>
</div>

